import React from 'react';
import styled from 'styled-components';
import { DocumentGroup } from '../../../types/documentGroup';
import GroupListItemMatch from './GroupListItemMatch';
import { DataMatchGroup } from '../../../types/proccesingJobs';

interface OwnProps {
  group: DocumentGroup;
  onToggleMatches: (isSet: boolean, matchGroup: DataMatchGroup) => void;
}

const GroupMatches = styled.div`
  width: 100%;
`;

const GroupListItemMatches = ({ group, onToggleMatches }: OwnProps) => {
  const matches = group?.processingJob?.output.crossMatchResult?.matches;

  return (
    <GroupMatches>
      {matches &&
        matches.length > 0 &&
        matches.map((match, matchIndex) => {
          const key = `match-${matchIndex}`;
          return (
            <GroupListItemMatch matchGroup={match} key={key} onToggleMatches={onToggleMatches} />
          );
        })}
    </GroupMatches>
  );
};

export default GroupListItemMatches;
